import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/hooks/hooks';
import { PageLoading } from '@/components/kit/ds/PageLoading';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that enforces:
 *  1. Authentication — unauthenticated users → /login
 *  2. Email verification (WEB-420) — authenticated but unverified → /verify-email
 *
 * isEmailVerified=undefined is treated as "pass" (grandfather: legacy sessions
 * issued before the gate existed should not be interrupted).
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAppSelector(
    (state) => state.auth,
  );

  // На время /auth/me — экран загрузки «первый заход» эталона, а не пустая
  // страница (ретро-сверка С9 30.10); защищённое до ответа не рисуется.
  if (isLoading) {
    return <PageLoading first />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // WEB-420: block cabinet access until email is confirmed.
  // Only block when explicitly false; undefined = legacy token → pass through.
  if (user?.isEmailVerified === false) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}
